import React from 'react';
import {
  ViewButton,
  EditButton,
  OpenUrlButton,
} from '../Common/DataTable/tableActionButtons';
import { getFilter } from '../Common/DataTable/tableHelpers';
import moment from 'moment';
import FromNow from '../Common/FromNow';
import getShortLinkBaseUrl from '../../config/shortLinks';
import useClipboard from '../../lib/useClipboard';
import toastr from 'toastr';

const shortLinkBaseUrl = getShortLinkBaseUrl();

const CopyLinkButton = ({ value }) => {
  const [, copyToClipboard] = useClipboard();

  const handleCopy = async () => {
    const fullUrl = `${shortLinkBaseUrl}/${value}`;
    const copied = await copyToClipboard(fullUrl);

    copied
      ? toastr.success('Link copied to clipboard!', 'Success')
      : toastr.error('Unable to copy the link to the clipboard!', 'Error');
  };

  return (
    <button
      type="button"
      className="btn btn-sm btn-outline-secondary ml-2"
      onClick={handleCopy}
      title="Copy link to clipboard">
      <i className="fa fa-copy"></i>
    </button>
  );
};

const createTableColumns = (openViewModal, openEditModal) => [
  {
    title: 'Slug',
    name: 'id',
    sorting: 'disabled',
    formatterComponent: ({ value }) => (
      <div className="d-flex align-items-center">
        <span>
          {shortLinkBaseUrl}/{value}
        </span>
        <CopyLinkButton value={value} />
      </div>
    ),
  },
  {
    title: 'Target',
    name: 'target',
  },
  {
    title: 'Description',
    name: 'description',
    width: 300,
  },
  {
    title: 'Clicks',
    name: 'clicks',
    width: 120,
  },
  {
    title: 'Last Click At',
    name: 'lastClickAt',
    width: 200,
    formatterComponent: ({ value }) => <FromNow value={value} />,
    filter: (value, filter) => getFilter(moment(value).fromNow(), filter.value),
    exportValue: ({ value }) => moment(value).format('DD/MM/YYYY HH:mm:ss'),
  },
  {
    title: 'Created At',
    name: 'createdAt',
    width: 200,
    formatterComponent: ({ value }) => <FromNow value={value} />,
    filter: (value, filter) => getFilter(moment(value).fromNow(), filter.value),
    exportValue: ({ value }) => moment(value).format('DD/MM/YYYY HH:mm:ss'),
  },
  {
    title: 'Action',
    name: 'action',
    width: 140,
    align: 'center',
    formatterComponent: ({ row }) => (
      <ul className="list-inline font-size-20 contact-links mb-0">
        <ViewButton row={row} onPress={openViewModal} />
        <EditButton row={row} onPress={openEditModal} />
        <OpenUrlButton row={row} url={`${shortLinkBaseUrl}/${row.id}`} />
      </ul>
    ),
    filter: 'disabled',
    sorting: 'disabled',
  },
];

export default createTableColumns;
